import { Check } from 'lucide-react';
import { cn } from '@sara/ui/lib/utils';
import { Command, CommandEmpty, CommandItem, CommandList } from '@sara/ui/components/command';
import type { FilterEditorProps } from '../types';

export function TemplateEditor({ search, interviewTypes, onChange, onClose }: FilterEditorProps) {
  const current = search.interviewTypeVersionId;

  function select(versionId: string) {
    onChange({ interviewTypeVersionId: versionId });
    onClose();
  }

  return (
    <Command>
      <CommandList>
        <CommandEmpty>No templates found.</CommandEmpty>
        {interviewTypes.map((t) => (
          <CommandItem
            key={t.latestVersionId}
            onSelect={() => select(t.latestVersionId)}
            className="flex items-center justify-between gap-2 text-[13px]"
          >
            {t.name}
            <Check
              className={cn('h-3.5 w-3.5 shrink-0', current !== t.latestVersionId && 'invisible')}
              strokeWidth={1.6}
            />
          </CommandItem>
        ))}
      </CommandList>
    </Command>
  );
}
